import { useCallback, useEffect } from 'react';
import LazySwiperController from '@/utils/Controllers/LazySwiperController';

const useCarouselRef = setCarouselIndex => {
  useEffect(() => {
    const loadSwiper = async () => {
      await LazySwiperController();
    };

    loadSwiper();
  }, []);

  const initCarousel = async node => {
    const LazySwiperLib = await LazySwiperController();
    const carousel = new LazySwiperLib(node, {
      a11y: {
        enabled: true,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        prevEl: document.querySelector(
          '.ken-configurator__carousel .swiper-button-prev',
        ),
        nextEl: document.querySelector(
          '.ken-configurator__carousel .swiper-button-next',
        ),
      },
      pagination: {
        el: document.querySelector(
          '.ken-configurator__carousel .swiper-pagination',
        ),
        clickable: true,
        type: 'bullets',
      },
      centeredSlides: true,
      slidesPerView: 1.3,
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 3,
      },
      on: {
        slideChange: () => {
          setCarouselIndex(carousel.activeIndex);
        },
      },
    });
  };

  const carouselRef = useCallback(node => {
    if (node) {
      initCarousel(node).catch(err => {
        console.error(err);
      });
    }
  }, []);

  return carouselRef;
};

export default useCarouselRef;
